import React from 'react';
import { useTranslation } from 'react-i18next';

import ListResource from './ListResource.jsx';
import { subjects } from '../../../../../../components/quiz/config/subjects';
import { getLang } from '../../../commons/helpers';

const ListTrainings = () => {
  const {
    i18n: { language },
  } = useTranslation();

  return (
    <ListResource
      {...{
        searchable: true,
        api: '/api/quiz/trainings',
        sort: { subject: 1, isSenior: -1 },
        cols: [
          {
            key: 'subject',
            children: 'Subject',
            sortable: true,
            getter: (v) => {
              const subjectObj = subjects[v];
              return subjectObj ? getLang(subjectObj, language) : v;
            },
          },
          {
            key: 'isSenior',
            children: 'Is Senior',
            sortable: true,
            getter: (v) => (v ? 'Yes' : 'No'),
          },
          { key: 'articles', children: 'Articles', getter: (v) => v.length },
        ],
      }}
    />
  );
};

export default ListTrainings;
